import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import api from '../../services/api';

export default function Logonsite() {
  sessionStorage.setItem('id', "");
  sessionStorage.setItem('name', "");
  sessionStorage.setItem('token', "");
  sessionStorage.setItem('email', "");
  sessionStorage.setItem('hashTag', '');
  const { t } = useTranslation();
  const history = useHistory();
  const params = window.location.search.substring(1).split('&');


  async function login(params) {
    //Criar objeto que vai conter os parametros
    let paramArray = [];

    //Passar por todos os parametros
    for (var i = 0; i < params.length; i++) {
      //Dividir os parametros chave e valor
      let param = params[i].split('=');

      //Adicionar ao objeto criado antes
      paramArray[decodeURIComponent(param[0])] = decodeURIComponent(param[1]);
    }
    const email = paramArray['form_fields[email]'];
    const password = paramArray['form_fields[password]'];
    try {
      const response = await api.post('/v4/users/sign_in', {email, password});
      sessionStorage.setItem('id', response.data.id);
      sessionStorage.setItem('name', response.data.name);
      sessionStorage.setItem('token', response.data.token);
      sessionStorage.setItem('email', response.data.email);

      //pegarDados();

      api.get(`/v4/users/me`, {
        headers: {
          'USER_EMAIL': sessionStorage.getItem('email'),
          'USER_TOKEN': sessionStorage.getItem('token'),
        }
      }).then(response => {
        sessionStorage.setItem('phone', response.data.phone);
        sessionStorage.setItem('tags', JSON.stringify(response.data.interested_tags));
        sessionStorage.setItem('plan', JSON.stringify(response.data.plan));
      });

      history.push('/timeline');

    } catch (err) {
      alert(t('pages.logonSite.errorLogin'));
      history.push('/');
    }
  }
  login(params);
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  return (
      <h1>.</h1>
  )
}